/* Local, accessible controls; all geographic shapes are rendered by Liquid. */
(() => {
  function setup(root) {
    if (root.dataset.mapReady) return;
    root.dataset.mapReady = 'true';
    let selected = null;
    const buttons = [...root.querySelectorAll('[data-market]')];
    const shapes = [...root.querySelectorAll('[data-market-shape]')];
    const highlight = (key) => shapes.forEach((shape) => {
      shape.classList.toggle('is-active', shape.dataset.marketShape === key);
    });
    buttons.forEach((button) => {
      button.addEventListener('mouseenter', () => highlight(button.dataset.market));
      button.addEventListener('mouseleave', () => highlight(selected));
      button.addEventListener('focus', () => highlight(button.dataset.market));
      button.addEventListener('blur', () => highlight(selected));
      button.addEventListener('click', () => {
        selected = selected === button.dataset.market ? null : button.dataset.market;
        buttons.forEach((other) => other.setAttribute('aria-pressed', String(other.dataset.market === selected)));
        highlight(selected);
      });
    });
  }
  document.querySelectorAll('[data-export-maps]').forEach(setup);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-export-maps]').forEach(setup));
})();
